package com.codeexamples.domain.model

case class User(id: String, displayName: String, photoUrl: String)
